// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrap":"UserNavDropdown_avatar-wrap__2u2tl","dropdown":"UserNavDropdown_dropdown__1WnEI"};